import { createDynamicThunk } from ".";

/**
 * LIST Survey
 */
export const fetchSurveyThunk = createDynamicThunk({
  typePrefix: "survey/fetchSurveyThunk",
  useHandleSearch: true,
});

export const fetchFormsThunk = createDynamicThunk({
  typePrefix: "fetchFormsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const saveFormsThunk = createDynamicThunk({
  typePrefix: "saveFormsThunk",
  endpoint: "/forms",
  method: "POST",
});

export const getVFormsListThunk = createDynamicThunk({
  typePrefix: "getVFormsListThunk",
  endpoint: "/forms/findAll",
  method: "POST",
});

export const saveSendFormsThunk = createDynamicThunk({
  typePrefix: "saveSendFormsThunk",
  endpoint: "/sendForms",
  method: "POST",
});

export const fetchFeedbackRequestsThunk = createDynamicThunk({
  typePrefix: "feedback-requests/fetchFeedbackRequestsThunk",
  useHandleSearch: true,
});
